var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 96 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 551.231q-49.5 0-83.212-33.712-33.711-33.711-33.711-83.468 0-49.756 33.711-83.211Q430.5 317.385 480 317.385t83.212 33.455q33.711 33.455 33.711 83.211 0 49.757-33.711 83.468Q529.5 551.231 480 551.231ZM200 840.616v-60.513q0-25.898 14.91-46.987 14.91-21.09 39.449-32.86 58.41-26.487 114.446-39.987 56.035-13.5 111.179-13.5 55.144 0 111.119 13.577 55.974 13.577 114.103 40.144 25.093 11.64 39.944 32.678Q760 754.205 760 780.103v60.513H200Zm33.846-33.846h492.308v-26.667q0-14.59-9.705-27.898-9.705-13.307-26.654-22.205-52.462-25.564-104.349-37.474Q533.559 680.615 480 680.615t-105.856 11.911Q321.846 704.436 270.051 730q-16.949 8.898-26.577 22.205-9.628 13.308-9.628 27.898v26.667ZM480 517.385q34.949 0 59.013-24.064 24.064-24.065 24.064-59.013 0-34.949-24.064-59.013T480 351.231q-34.949 0-59.013 24.064t-24.064 59.013q0 34.948 24.064 59.013 24.064 24.064 59.013 24.064Zm0-83.077Zm0 372.462Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon-person.bd0554365aa9f376acc4c7b266e666eb.svg";
export { ForwardRef as ReactComponent };